import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './filters'
import NewsletterModal from './plugins/newsletter/NewsletterModal.js';
import LazyLoadDirective from "./directives/LazyLoadDirective";
import Settings from './settings'
import Static from './plugins/static'
import AlyssaGoldwater from './other/AlyssaGoldwater.vue'
import FiveTownCentral from './other/FiveTownCentral.vue'
import Momazon from './other/Momazon.vue'
import VueYouTubeEmbed from 'vue-youtube-embed'
var VueCookie = require('vue-cookie');

Vue.config.productionTip = false;
Vue.use(VueCookie);
Vue.use(NewsletterModal);
Vue.directive("lazyload", LazyLoadDirective);


if (Settings.siteName == 'mommydeals') {
    Vue.use(VueYouTubeEmbed)
}

Vue.use(Static);

switch (Settings.siteName) {
    case 'alyssagoldwater': {
        new Vue({
            router,
            render: h => h(AlyssaGoldwater)
        }).$mount('#app')
        break;
    }
    case 'fivetowncentral': {
        new Vue({
            router,
            render: h => h(FiveTownCentral)
        }).$mount('#app')
        break;
    }
    case 'momazon': {
        new Vue({
            router,
            render: h => h(Momazon)
        }).$mount('#app')
        break;
    }
    default:
    {
        new Vue({
            router,
            render: h => h(App)
        }).$mount('#app')
        break;
    }
}


